function initCTACheckboxes( container ) {
    var checkboxes = container.querySelectorAll( 'input[data-ts-cta-checkbox]' ) || [];
    var textarea = container.querySelector( '[name=message]' );

    var isWhitespaceOnly = /^\s{1,}$/;

    if ( textarea ) {
        textarea.addEventListener( 'change', function() {
            textarea.value = textarea.value.trim();
        } );
    }

    function updateContactBtns( key, value ) {
        document.querySelectorAll( '.contact-url-updatable' ).forEach( ( btn ) => {
            const params = new URLSearchParams( btn.dataset.actionParams || '' );
            params.set( key, value );
            btn.dataset.actionParams = params.toString();
        } );
    }

    checkboxes.forEach( function( checkbox ) {
        checkbox.addEventListener( 'click', function( event ) {
            var text = event.target.dataset.tsText;
            var action = event.target.dataset.tsCtaAction;
            var checked = event.target.checked;
            var textAreaText = textarea.value;

            updateContactBtns( action, checked );

            if ( checked ) {
                if ( textAreaText.length === 0 ) {
                    textarea.value = text + ' ';
                } else if ( !textAreaText.includes( text ) ) {
                    textarea.value = textAreaText.trim() + ' ' + text + ' ';
                }

                if ( action === 'ask-question' ) {
                    textarea.style.display = 'block';

                    const showTextAreaBtn = container.querySelector( '[data-ts-cta-ask]' );

                    if ( showTextAreaBtn ) {
                        showTextAreaBtn.remove();
                    }
                }
            } else {
                textarea.value = textAreaText.replace( text, '' );

                if ( textarea.value.length > 0 ) {
                    textarea.value = textarea.value.trim() + ' ';
                }

                if ( isWhitespaceOnly.test( textarea.value ) ) {
                    textarea.value = '';
                }
            }
        } );
    } );

    var options = window.router.currentState.meta || {};
    var hasOptions = Object.keys( options ).length > 0;

    if ( hasOptions ) {
        Object.keys( options ).forEach( function( key ) {
            if ( key === 'make-offer' ) {
                updateContactBtns( key, options[ key ] );

                if ( options[ key ] === true && options[ 'offer-quantity' ] ) {
                    updateContactBtns( 'offer-quantity', options[ 'offer-quantity' ] );
                }

                return;
            }

            document.querySelectorAll( 'input[data-ts-cta-action="' + key + '"]' ).forEach( function() {
                updateContactBtns( key, options[ key ] );
            } );
        } );
    }
}

export default initCTACheckboxes;
